<!doctype html>
<html lang="en">

<style>
  h2, #txtSearch, #selectType, #btnSearchResult{
    font-family: 'Kanit'
  }

  h3{
    font-family: 'Chakra Petch'
  }
</style>

<!-- <script src="https://www.google.com/recaptcha/api.js?render=6Le62rkZAAAAAN9V8jrF3N6ybBEJvEEWaaj2yTHO"></script>
<script>
      function onClick(e) {
        e.preventDefault();
        grecaptcha.ready(function() {
          grecaptcha.execute('reCAPTCHA_site_key', {action: 'submit'}).then(function(token) {
              // Add your logic to submit to your backend server here.
          });
        });
      }
</script> -->

<head>

  <!-- Basic Page Needs
  ================================================== -->
  <title>ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า</title>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">

</head>

<body>
  <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response" value="">
  <!-- <div id="fb-root"></div>
  <script async defer crossorigin="anonymous" src="https://connect.facebook.net/th_TH/sdk.js#xfbml=1&version=v7.0" nonce="UKkPDujp"></script> -->
  <!-- Wrapper -->
  <div id="wrapper" class="wrapper-with-transparent-header">
    <app-header-mainindex></app-header-mainindex>

    <div class="clearfix"></div>
    <!-- Header Container / End -->

    <div class="intro-banner dark-overlay" data-background-image="../assets/images/home-background-02.jpg">

      <!-- Transparent Header Spacer -->
      <div class="transparent-header-spacer"></div>

      <div class="container">

        <!-- Intro Headline -->
        <div class="row">
          <div class="col-md-12">
            <div class="banner-headline">
              <h2>
                <strong>บริการค้นหาและแนะนำประเภทธุรกิจ (TSIC)</strong>
              </h2>
              <p style="color:#FEBD01">
                <span style="font-family: 'Chakra Petch'">โดย กรมพัฒนาธุรกิจการค้า </span>
                <span style="font-family: 'Chakra Petch'; font-size: 14px;"><br>อ้างอิงตามการจัดประเภทมาตรฐานอุตสาหกรรม (ประเทศไทย) ปี 2552 ของกรมการจัดหางาน กระทรวงแรงงาน</span>
              </p>
              <!-- Share Buttons -->
              <div class="share-buttons margin-top-20">
                <div class="share-buttons-trigger"><i class="icon-feather-share-2"></i></div>
                <div class="share-buttons-content">
                  <span style="color:#FEBD01; font-family: 'Chakra Petch'">Was this information helpful? <strong>Share It!</strong></span>
                  <ul class="share-buttons-icons">
                    <div id="fb-root"></div>
                    <li><div id="btnShare" class="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/" data-layout="box_count" data-size="small"><a target="_blank" data-button-color="#3b5998" title="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=https://www.facebook.com/pages/category/Government-Organization/DBD-Public-Relations-415527945210102/;src=sdkpreparse" class="fb-xfbml-parse-ignore"><i class="icon-brand-facebook-f"></i></a></div></li>
                    <!-- <li><a href="#" data-button-color="#3b5998" title="Share on Facebook" data-tippy-placement="top"><i class="icon-brand-facebook-f"></i></a></li> -->
                    <li><a target="_blank" href="http://twitter.com/share?text=ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า&url=https://twitter.com/relationdbd" data-button-color="#1da1f2" title="Share on Twitter" data-tippy-placement="top"><i class="icon-brand-twitter"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="g-recaptcha"
              data-sitekey="reCAPTCHA_site_key"
              data-callback='onSubmit'
              data-action='submit'></button>

        <!-- Search Bar -->
        <div class="row">
          <div class="col-md-12">
            <div class="intro-banner-search-form margin-top-95">

              <!-- Search Field -->
              <div class="intro-search-field">
                    <!-- <label for="txtSearch" class="field-title ripple-effect" style="font-family: 'Chakra Petch'">กรุณาระบุคำค้น</label> -->
                    <!-- <select #selectType id="selectType" > -->
                      <select #selectType class="custom-select" style="font-family: 'Kanit'">
                        <option value="0" selected>ทุกประเภทกิจการ</option>
                        <option value="1">ผลิต</option>
                        <option value="2">ขายส่ง</option>
                        <option value="3">ขายปลีก</option>
                        <option value="4">บริการ</option>
                      </select>
              </div>
              <input #textSearch id="txtSearch" type="text"  placeholder="ระบุกิจกรรมทางธุรกิจ เช่น ขายเสื้อผ้าออนไลน์ หรือรหัสธุรกิจที่ต้องการ เช่น 47912" (keyup.Enter)="searchData(textSearch.value, selectType.value)" style="margin-top: auto; margin-bottom: auto;"><!-- $event.target.value -->
              <!-- Button -->
              <div class="intro-search-button">
                <button class="button ripple-effect" id="btnSearchResult" (click)="searchData(textSearch.value, selectType.value)" style="height: 100%;">ค้นหา </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Stats -->
        <div class="row" style="font-family: 'Kanit'">
          <div class="col-md-12">
            <ul class="intro-stats margin-top-45 hide-under-992px">
              <li>
                <strong class="counter" id="countBizType"></strong>
                <span>จำนวนประเภทธุรกิจ</span>
              </li>
              <li>
                <strong class="counter" id="countProduct"></strong>
                <span>จำนวนสินค้าและบริการ</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>


    <!-- Content
  ================================================== -->

    <!-- Popular Job Categories -->
    <div class="section margin-top-65 margin-bottom-30">
      <div class="container">
        <div class="row">

          <!-- Section Headline -->
          <div class="col-xl-12">
            <div class="section-headline centered margin-top-0 margin-bottom-45">
              <h2><strong style="font-family: 'Kanit'">รายการรหัสประเภทธุรกิจ จำแนกตามหมวดธุรกิจ (Section) 21 หมวด (A-U)</strong></h2>
              <h5 style="color:#FEBD01; font-family: 'Chakra Petch'">ดาวน์โหลด คำอธิบายรหัสธุรกิจ TSIC ปี 2552 "การจัดประเภทธุรกิจของนิติบุคคล" <a href="../assets/book_business_man.pdf">คลิกที่นี่</a></h5>
            </div>
          </div>

          <!-- <div class="col-xl-3 col-md-6" *ngFor="let business of business_group">
            <a (click)="searchByCategory(business.OBJGRP)" class="photo-box small" style="background-image: url('../assets/images/a-z_images/{{business.IMG}}');" >
              <div class="photo-box-content">
                <h3>{{business.OBJGRP}}</h3>
                <h3>{{business.OBJGRP_DESC}}</h3>
                <span>{{business.COUNT}}</span>
              </div>
            </a>
          </div> -->
          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('A')" class="photo-box small" data-background-image="../assets/images/a-z_images/a.jpg">
              <div class="photo-box-content">
                <h3>A</h3>
                <h3>เกษตรกรรม การป่าไม้ และการประมง</h3>
                <span>106</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('B')" class="photo-box small" data-background-image="../assets/images/a-z_images/b.jpg">
              <div class="photo-box-content">
                <h3>B</h3>
                <h3>การทำเหมืองแร่ และเหมืองหิน</h3>
                <span>22</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('C')" class="photo-box small" data-background-image="../assets/images/a-z_images/c.jpg">
              <div class="photo-box-content">
                <h3>C</h3>
                <h3>การผลิต</h3>
                <span>382</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('D')" class="photo-box small" data-background-image="../assets/images/a-z_images/d.jpg">
              <div class="photo-box-content">
                <h3>D</h3>
                <h3>ไฟฟ้า ก๊าซ ไอน้ำ และระบบการปรับอากาศ</h3>
                <span>6</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('E')" class="photo-box small" data-background-image="../assets/images/a-z_images/e.jpg">
              <div class="photo-box-content">
                <h3>E</h3>
                <h3>การจัดหาน้ำ การจัดการน้ำเสีย และของเสียรวมถึงกิจกรรมที่เกี่ยวข้อง</h3>
                <span>15</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('F')" class="photo-box small" data-background-image="../assets/images/a-z_images/f.jpg">
              <div class="photo-box-content">
                <h3>F</h3>
                <h3>การก่อสร้าง</h3>
                <span>22</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('G')" class="photo-box small" data-background-image="../assets/images/a-z_images/g.jpg">
              <div class="photo-box-content">
                <h3>G</h3>
                <h3>การขายส่งและการขายปลีก การซ่อมยานยนต์และจักรยานยนต์</h3>
                <span>168</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('H')" class="photo-box small" data-background-image="../assets/images/a-z_images/h.jpg">
              <div class="photo-box-content">
                <h3>H</h3>
                <h3>การขนส่งและสถานที่เก็บสินค้า</h3>
                <span>52</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('I')" class="photo-box small" data-background-image="../assets/images/a-z_images/i.jpg">
              <div class="photo-box-content">
                <h3>I</h3>
                <h3>ที่พักแรมและบริการด้านอาหาร</h3>
                <span>18</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('J')" class="photo-box small" data-background-image="../assets/images/a-z_images/j.jpg">
              <div class="photo-box-content">
                <h3>J</h3>
                <h3>ข้อมูลข่าวสารและการสื่อสาร </h3>
                <span>54</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('K')" class="photo-box small" data-background-image="../assets/images/a-z_images/k.jpg">
              <div class="photo-box-content">
                <h3>K</h3>
                <h3>กิจกรรมทางการเงินและการประกันภัย</h3>
                <span>43</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('L')" class="photo-box small" data-background-image="../assets/images/a-z_images/l.jpg">
              <div class="photo-box-content">
                <h3>L</h3>
                <h3>กิจกรรมเกี่ยวกับอสังหาริมทรัพย์ </h3>
                <span>6</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('M')" class="photo-box small" data-background-image="../assets/images/a-z_images/m.jpg">
              <div class="photo-box-content">
                <h3>M</h3>
                <h3>กิจกรรมวิชาชีพวิทยาศาสตร์และกิจกรรมทางวิชาการ</h3>
                <span>29</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('N')" class="photo-box small" data-background-image="../assets/images/a-z_images/n.jpg">
              <div class="photo-box-content">
                <h3>N</h3>
                <h3>กิจกรรมการบริหารและบริการสนับสนุน</h3>
                <span>43</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('O')" class="photo-box small" data-background-image="../assets/images/a-z_images/o.jpg">
              <div class="photo-box-content">
                <h3>O</h3>
                <h3>การบริหารราชการ การป้องกันประเทศและการประกันสังคมภาคบังคับ</h3>
                <span>21</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('P')" class="photo-box small" data-background-image="../assets/images/a-z_images/p.jpg">
              <div class="photo-box-content">
                <h3>P</h3>
                <h3>การศึกษา</h3>
                <span>26</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('Q')" class="photo-box small" data-background-image="../assets/images/a-z_images/q.jpg">
              <div class="photo-box-content">
                <h3>Q</h3>
                <h3>กิจกรรมด้านสุขภาพและงานสังคมสงเคราะห์</h3>
                <span>23</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('R')" class="photo-box small" data-background-image="../assets/images/a-z_images/r.jpg">
              <div class="photo-box-content">
                <h3>R</h3>
                <h3>ศิลปะ ความบันเทิงและนันทนาการ</h3>
                <span>21</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('S')" class="photo-box small" data-background-image="../assets/images/a-z_images/s.jpg">
              <div class="photo-box-content">
                <h3>S</h3>
                <h3>กิจกรรมการบริการด้านอื่น ๆ</h3>
                <span>36</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('T')" class="photo-box small" data-background-image="../assets/images/a-z_images/t.jpg">
              <div class="photo-box-content">
                <h3>T</h3>
                <h3>กิจกรรมการจ้างงานในครัวเรือน กิจกรรมการผลิตสินค้า และบริการที่ทำขึ้นเองเพื่อใช้ในครัวเรือนฯ</h3>
                <span>3</span>
              </div>
            </a>
          </div>

          <div class="col-xl-3 col-md-6">
            <!-- Photo Box -->
            <a (click)="searchByCategory('U')" class="photo-box small" data-background-image="../assets/images/a-z_images/u.jpg">
              <div class="photo-box-content">
                <h3>U</h3>
                <h3>กิจกรรมขององค์การระหว่างประเทศและภาคีสมาชิก</h3>
                <span>2</span>
              </div>
            </a>
          </div>

        </div>

      </div>
    </div>
    <!-- Features Cities / End -->

    <!-- Photo Section -->
    <!-- Infobox -->
    <!-- <div class="photo-section" data-background-image="../assets/images/section-background.jpg">


      <div class="text-content white-font">
        <div class="container">

          <div class="row">
            <div class="col-lg-10 col-md-10 col-sm-12">
              <h2 style="color:#FEBD01"><strong>DBD DataWarehouse<sup>+</sup></strong></h2>
              <h2>แหล่งค้นหาข้อมูลนิติบุคคล และประเภทธุรกิจในประเทศไทย</h2>
              <a href="https://datawarehouse.dbd.go.th/" target="_blank" class="button button-sliding-icon ripple-effect big margin-top-20">เริ่มต้นใช้งาน <i class="icon-material-outline-arrow-right-alt"></i></a>
            </div>
          </div>

        </div>
      </div>



    </div> -->
    <!-- Infobox / End -->
    <!-- Photo Section / End -->

    <!-- Counters -->
   <div class="section padding-top-70 padding-bottom-75">
     <!-- <div class="container"> -->
       <div class="row" style="font-family: 'Kanit'">
         <!-- <div class="col-xl-12"> -->
           <!-- <div class="counters-container"> -->

             <!-- Counter -->
         <div class="col-6 col-md-6">
             <div class="single-counter">
               <i class="icon-line-awesome-user"></i>
               <div class="counter-inner">
                 <h3><span class="counter" id="lastUsed"></span></h3>
                 <span class="counter-title">จำนวนผู้เข้าชม</span>
               </div>
             </div>
         </div>

             <!-- Counter -->
         <div class="col-6 col-md-6">
             <div class="single-counter">
               <i class="icon-line-awesome-search"></i>
               <div class="counter-inner">
                 <h3><span class="counter" id="countSearchHistory"></span></h3>
                 <span class="counter-title">จำนวนการค้นหา</span>
               </div>
             </div>
           </div>

           <!-- </div> -->
         <!-- </div> -->
       </div>


       <div class="row" style="margin-top: 20px; font-family: 'Kanit'">
         <div class="single-counter">
           <i class="icon-line-awesome-calendar"></i>
           <div class="counter-inner">
             <h3><span class="counter" id="countSearchHistory"></span></h3>
             <span class="counter-title">นับตั้งแต่ ธันวาคม 2563</span>
           </div>
         </div>
       </div>
     <!-- </div> -->
   </div>
   <!-- Counters / End -->


    <!-- Footer
  ================================================== -->
    <div id="footer">

      <!-- Footer Copyrights -->
      <div class="footer-bottom-section">
        <div class="container">
          <div class="row" style="font-family: 'Kanit'">
            <div class="col-xl-12">
              ติดต่อเรา กองข้อมูลธุรกิจ โทร 02-547-4391
            </div>
            <div class="col-xl-12">
              จัดทำโดย กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์ (สนามบินน้ำ) 563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000
            </div>
            <div class="col-xl-12">
              © 2020 <strong>Department of Business Development</strong>. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
      <!-- Footer Copyrights / End -->

    </div>
    <!-- Footer / End -->

  </div>
  <!-- Wrapper / End -->


</body>

</html>
